{
  "schemaVersion": "cogo.backoffice-report-contract.v1",
  "contractId": "gridone-housing-report-promotion",
  "status": "promoted",
  "publicDomain": "cogo.xyz",
  "sourceRuntimePolicy": {
    "acceptedRuntimeSources": ["local-file", "csv", "json-manifest"],
    "excelRuntimeDependency": false,
    "excelUse": "extraction-only",
    "rawWorkbookFormulaAllowed": false
  },
  "coverageRequirements": {
    "formulaCells": 867170,
    "formulaFillPatterns": 828,
    "formulaGroups": 88,
    "reportSections": 40,
    "dataTables": 22,
    "tableCells": 2972,
    "chartSurfaces": 23,
    "chartRows": 2872,
    "workbookChartParts": 16,
    "documentSlots": 40,
    "unavailableDocumentSlots": 5,
    "coverageLedgerRows": 257,
    "blockingGapIds": []
  },
  "requiredCoverageKinds": [
    "local_csv_file",
    "formula_group",
    "formula_recipe",
    "report_section",
    "data_table",
    "chart_surface",
    "workbook_chart_part",
    "document_slot"
  ],
  "requiredProofGates": [
    "local_csv_source_integrity",
    "formula_fill_pattern_mining",
    "formula_pattern_recipe_instance_compile",
    "formula_cell_golden_parity",
    "formula_recipe_runtime_parity",
    "headless_cogo_runtime_smoke",
    "chart_source_row_parity",
    "workbook_chart_extraction_parity",
    "browser_chart_render_parity",
    "all_table_browser_dom_parity",
    "all_report_sections_rendered",
    "document_export_parity",
    "retrieval_change_planner_standardization",
    "cogo_namespace_and_local_policy"
  ],
  "retrievalContract": {
    "authority": "coverage-ledger ontology chunks with source/evidence refs",
    "plannerOwned": true,
    "rawCogoJsonAllowed": false,
    "requiredChunkFields": [
      "chunkId",
      "kind",
      "ontologySubject",
      "sourceRef",
      "cogoTargetRef",
      "proofRef"
    ],
    "requiredScenarioIds": [
      "change-weekly-ranking-top-n",
      "preserve-mixed-bar-line-combo-chart",
      "export-monthly-docx-hwpx-report"
    ],
    "allowedPatchTypes": [
      "formula-report-change",
      "chart-ontology-change",
      "document-export-change"
    ],
    "requiredRerunGates": [
      "agentic:cogo-housing-full-coverage-audit",
      "agentic:cogo-housing-browser-e2e",
      "agentic:cogo-housing-document-export-parity"
    ]
  },
  "documentExportContract": {
    "formats": ["docx", "hwpx"],
    "hangulCanonicalFormat": "hwpx",
    "hangulCanonicalFormatDescription": "HWPX open XML-based Hangul-family package",
    "hwpBinaryScope": "excluded",
    "requiredReadbackPassCount": 2,
    "requiredArtifactDownloadReadbackCount": 2,
    "requiredTableSlotRefCount": 22,
    "requiredChartSlotRefCount": 23,
    "unavailableSlotsExportedAsPlaceholders": true
  },
  "documentExportServiceContract": {
    "schemaVersion": "cogo.housing.document-export-service-manifest.v1",
    "artifact": "document-export-service-manifest.json",
    "runtimeModule": "scripts/agentic/cogo-housing-document-export-service-manifest.ts",
    "operationId": "backofficeReport.exportDocument",
    "route": "POST /v1/backoffice-report/document-export",
    "responseSchema": "cogo.backoffice-report.document-export-response.v1",
    "requiredArtifactCount": 2,
    "requiredFormats": ["docx", "hwpx"],
    "requiredDownloadPathPrefix": "/v1/backoffice-report/document-export/artifacts/",
    "artifactBytesEmbedded": false,
    "requiredReadbackPassCount": 2,
    "requiredArtifactDownloadReadbackCount": 2,
    "requiredTableSlotRefCount": 22,
    "requiredChartSlotRefCount": 23,
    "hwpBinaryScope": "excluded"
  },
  "productApplicationContract": {
    "schemaVersion": "cogo.product-application.v1",
    "artifact": "generated-cogo-housing-product.cogo-v2.json",
    "proofArtifact": "source-first/product-cogo-compiler-proof.v1.json",
    "applicationKind": "cogo.report-application",
    "reportApplicationSchemaVersion": "cogo.report-application.v1",
    "reportApplicationKind": "source-first-backoffice-report",
    "maxProductJsonBytes": 250000,
    "requiredDatasourceCount": 3,
    "requiredBlockCount": 5,
    "requiredViewCount": 5,
    "requiredActionFlowCount": 5,
    "requiredActionFlowIds": [
      "loadReport",
      "selectSection",
      "selectTable",
      "selectChart",
      "exportDocument"
    ],
    "mixedBarLinePreservationRequired": true,
    "sourceDataInlineAllowed": false,
    "bindingPlanEmbedded": false,
    "sourceRowDataEmbedded": false,
    "excelRuntimeDependency": false,
    "hwpBinaryScope": "excluded",
    "requiredDatasourceIds": [
      "cogo.housing.bindingPlan",
      "cogo.housing.excelChartSurfaces",
      "cogo.housing.localCsvManifest"
    ],
    "designSystemInjection": {
      "schemaVersion": "cogo.report-design-system-injection.v1",
      "designSystemId": "reb-rone-report-v1",
      "sourceAuthority": [
        "https://www.reb.or.kr/",
        "https://www.reb.or.kr/r-one/portal/main/indexPage.do"
      ],
      "uiOwns": "structure-semantics-data-actionflow",
      "designSystemOwns": "visual-surface-color-radius-typography",
      "rawVisualClassNamesAllowedInCogoUi": false
    }
  },
  "productReportBrowserProofContract": {
    "schemaVersion": "cogo.housing.product-report-browser-proof.v1",
    "artifact": "cogo-housing-product-report-browser-proof.json",
    "hydratedArtifact": "generated-cogo-housing-product.browser-hydrated.cogo-v2.json",
    "runtimeModule": "scripts/agentic/cogo-housing-product-report-browser-proof.ts",
    "packageScript": "agentic:cogo-housing-product-report-browser-proof",
    "targetAudience": "user-facing",
    "compactProductJsonRequired": true,
    "localCsvHydrationRequired": true,
    "requiredDesignSystemId": "reb-rone-report-v1",
    "requiredShellGateIds": [
      "P0 compact-product-shell-contract",
      "P1 cogo-ui-design-system-separated",
      "P2 user-facing-admin-shell-visible",
      "P3 header-and-input-density-quality",
      "P4 a4-report-content-rendered",
      "P5 browser-screenshot-nonblank-no-render-errors"
    ],
    "requiredScreenshotCount": 1,
    "requiredA4Canvas": {
      "pageFormat": "A4",
      "orientation": "portrait"
    },
    "requiredGlobalCommandHeader": true,
    "requiredWebMcpChatCommandInput": true,
    "requiredCollapsibleSidebar": true,
    "requiredNarrativeChartTable": true,
    "forbiddenCompletionClaim": "data-parity-harness-is-product-app"
  },
  "applicationCompositionClassification": {
    "schemaVersion": "cogo.application-composition-classification.v1",
    "methodologyContract": "cogo.application-composition-methodology.v1",
    "classification": "application-instance-fixture",
    "fixtureId": "gridone-housing-analysis-app",
    "promotedUiOntology": false,
    "promotedDesignOntology": false,
    "fixedComponentOntologyRequired": true,
    "fixedDesignSystemStructureRequired": true,
    "layoutPatternRefs": [
      "sidebar-workspace",
      "document-page",
      "dashboard-grid"
    ],
    "pagePatternRefs": [
      "admin-workspace-page",
      "analysis-page"
    ],
    "blockPatternRefs": [
      "command-header",
      "sidebar-navigation",
      "filter-toolbar",
      "chart-table-composition",
      "document-export-panel"
    ],
    "forbiddenCompletionClaim": "gridone-report-is-cogo-ui-ontology-standard"
  },
  "applicationCompositionFullClosureContract": {
    "schemaVersion": "cogo.application-composition-full-closure.v1",
    "runtimeModule": "packages/cogo-headless/src/application-composition-full-closure.ts",
    "runnerModule": "packages/cogo-headless/src/scripts/run-application-composition-full-closure.ts",
    "packageScript": "agentic:application-composition-full-closure",
    "proofArtifact": "docs/agentic/evidence/application-composition-full-closure-proof.json",
    "requiredWorkstreamCount": 8,
    "requiredStatus": "pass",
    "requiresPatternMining": true,
    "requiresPromotionGate": true,
    "requiresDesignSystemInjectionGate": true,
    "requiresProductHarnessSeparation": true,
    "requiresBrowserE2eProofContract": true,
    "forbiddenCompletionClaim": "methodology-doc-only"
  },
  "reportApplicationUxContract": {
    "schemaVersion": "cogo-report-application-shell-contract.v1",
    "runtimeModule": "packages/cogo-headless/src/lint-report-application-shell.ts",
    "validatorPackage": "@cogo/headless-core/lint-report-application-shell",
    "validatorFunction": "assessReportApplicationShell",
    "validationMode": "strict-fail-closed",
    "applicationKind": "cogo.report-application",
    "userFacingApplicationRequired": true,
    "validationHarnessMustBeSeparateArtifact": true,
    "requiredGlobalCommandHeader": true,
    "requiredWebMcpChatCommandInput": true,
    "requiredReportCommonControlsInHeader": true,
    "requiredCollapsibleSidebar": true,
    "requiredFullHeightSidebar": true,
    "requiredReportCanvas": {
      "pageFormat": "A4",
      "orientation": "portrait"
    },
    "requiredCanvasRegions": [
      "report-narrative",
      "chart-surface",
      "data-table"
    ],
    "forbiddenCompletionClaim": "validation-harness-only"
  },
  "platformStudioReadinessContract": {
    "schemaVersion": "cogo.housing.platform-studio-readiness-contract.v1",
    "artifact": "platform-studio-readiness-contract.json",
    "requiredReadinessStatus": "ready",
    "publishReadinessAllowed": true,
    "requiredEvidencePanel": true,
    "requiredEvidenceArtifactCount": 12,
    "productServiceDomain": "cogo.xyz",
    "productGridoneDomainAllowed": false,
    "studioFilesTouched": false,
    "requiredPublishGateIds": [
      "R3B_COGO_BINDING_PLAN",
      "R4_COMPACT_COGO_JSON_BINDING",
      "B0 source-first-cogo-binding-plan-consumed",
      "B4b excel-workbook-chartpart-surface-parity",
      "B5 all-chart-panels-rendered",
      "B6 all-source-table-dom-value-parity",
      "B7 all-report-section-surfaces-rendered",
      "H0 source-first-cogo-binding-plan-readiness"
    ]
  },
  "platformServiceDispatchContract": {
    "schemaVersion": "cogo.housing.platform-service-dispatch-proof.v1",
    "artifact": "platform-service-dispatch-proof.json",
    "runtimeModule": "scripts/agentic/cogo-housing-backoffice-report-service.ts",
    "requiredOperationCount": 5,
    "requiredDispatchCount": 7,
    "requiredQueryDispatchCount": 3,
    "requiredRoutes": [
      "POST /v1/backoffice-report/query",
      "POST /v1/backoffice-report/change-plan/compile",
      "POST /v1/backoffice-report/change-plan/execute",
      "POST /v1/backoffice-report/document-export",
      "GET /v1/backoffice-report/full-audit"
    ],
    "sourceOfTruthArtifacts": [
      "platform-studio-readiness-contract.json",
      "cogo-housing-application-service-contract-proof.json",
      "document-export-service-manifest.json"
    ]
  },
  "platformLocalApiReadbackContract": {
    "schemaVersion": "cogo.housing.platform-local-api-readback-proof.v1",
    "artifact": "platform-local-api-readback-proof.json",
    "runtimeModule": "scripts/agentic/cogo-housing-platform-local-api-readback.ts",
    "serviceRuntimeModule": "scripts/agentic/cogo-housing-backoffice-report-service.ts",
    "requiredOperationCount": 5,
    "requiredHttpReadbackCount": 7,
    "requiredHttpReadbackPassCount": 7,
    "requiredArtifactDownloadReadbackCount": 2,
    "localReadbackOnly": true,
    "productionLiveReadback": false,
    "requiredRoutes": [
      "POST /v1/backoffice-report/query",
      "POST /v1/backoffice-report/change-plan/compile",
      "POST /v1/backoffice-report/change-plan/execute",
      "POST /v1/backoffice-report/document-export",
      "GET /v1/backoffice-report/full-audit"
    ]
  },
  "platformOpenApiContract": {
    "schemaVersion": "cogo.housing.platform-openapi-conformance-proof.v1",
    "openApiArtifact": "platform-openapi.v1.json",
    "proofArtifact": "platform-openapi-conformance-proof.json",
    "runtimeModule": "scripts/agentic/cogo-housing-platform-openapi-contract.ts",
    "openApiVersion": "3.1.0",
    "requiredOperationCount": 5,
    "requiredOpenApiPathCount": 6,
    "requiredArtifactDownloadPath": "/v1/backoffice-report/document-export/artifacts/{artifactId}",
    "officialDomain": "cogo.xyz",
    "productionLiveReadback": false,
    "productionPromotionStatus": "pending-live-platform-readback",
    "requiredRoutes": [
      "POST /v1/backoffice-report/query",
      "POST /v1/backoffice-report/change-plan/compile",
      "POST /v1/backoffice-report/change-plan/execute",
      "POST /v1/backoffice-report/document-export",
      "GET /v1/backoffice-report/full-audit"
    ]
  },
  "requestServiceE2eContract": {
    "schemaVersion": "cogo.housing.request-service-e2e-proof.v1",
    "artifact": "request-service-e2e-proof.json",
    "runtimeModule": "scripts/agentic/cogo-housing-request-service-e2e.ts",
    "requiredRequestCount": 3,
    "requiredRequestPassCount": 3,
    "requiredQueryHttpReadbackCount": 3,
    "requiredCompiledMutationCount": 3,
    "requiredRuntimePassCount": 3,
    "requiredDocumentArtifactDownloadPassCount": 2,
    "plannerOwned": true,
    "rawCogoJsonAllowed": false,
    "productionLiveReadback": false
  },
  "platformLiveApiReadbackContract": {
    "schemaVersion": "cogo.housing.platform-live-api-readback-proof.v1",
    "artifact": "platform-live-api-readback-proof.json",
    "runtimeModule": "scripts/agentic/cogo-housing-platform-live-api-readback.ts",
    "serviceRuntimeModule": "scripts/agentic/cogo-housing-backoffice-report-service.ts",
    "executionMode": "opt-in",
    "requiredBaseUrl": "https://api.cogo.xyz",
    "officialDomain": "cogo.xyz",
    "requiredOperationCount": 5,
    "requiredHttpReadbackPassCount": 7,
    "requiredArtifactDownloadReadbackPassCount": 2,
    "localReadbackOnly": false,
    "productionLiveReadbackRequiredForPromotion": true,
    "dryRunAllowedBeforeDeployment": true,
    "requiredRoutes": [
      "POST /v1/backoffice-report/query",
      "POST /v1/backoffice-report/change-plan/compile",
      "POST /v1/backoffice-report/change-plan/execute",
      "POST /v1/backoffice-report/document-export",
      "GET /v1/backoffice-report/full-audit"
    ]
  },
  "goalCompletionAuditContract": {
    "schemaVersion": "cogo.housing.goal-completion-audit.v1",
    "artifact": "goal-completion-audit.json",
    "runtimeModule": "scripts/agentic/cogo-housing-goal-completion-audit.ts",
    "packageScript": "agentic:cogo-housing-goal-completion-audit",
    "finalAuditPackageScript": "agentic:cogo-housing-final-audit",
    "requiredRequirementCount": 8,
    "requiredLocalReady": true,
    "requiredProductionReadyBeforeLiveReadback": false,
    "requiredProvedRequirementCountBeforeLiveReadback": 7,
    "requiredPendingRequirementIdBeforeLiveReadback": "R8_PRODUCTION_COGO_XYZ_READBACK",
    "requiredProductionReadyAfterLiveReadback": true,
    "requiredProvedRequirementCountAfterLiveReadback": 8,
    "requiredPendingRequirementCountAfterLiveReadback": 0,
    "requiredProductionPromotionStatusAfterLiveReadback": "ready",
    "hardCompleteFlag": "--require-complete",
    "hardCompletePackageScript": "agentic:cogo-housing-goal-completion-audit:require"
  },
  "studioIngestionBridgeContract": {
    "schemaVersion": "cogo.housing.studio-ingestion-bridge.v1",
    "artifact": "studio-ingestion-bridge.json",
    "runtimeModule": "scripts/agentic/cogo-housing-studio-ingestion-bridge.ts",
    "requiredStudioLocalImportGate": "pass",
    "studioPreviewShareReady": true,
    "requiredProductionServiceGateBeforeLiveReadback": "expected-blocked-until-live-platform-readback",
    "requiredProductionServiceGateAfterLiveReadback": "ready-after-live-platform-readback",
    "requiredLocalReadbackArtifact": "platform-local-api-readback-proof.json",
    "requiredOpenApiArtifact": "platform-openapi.v1.json",
    "requiredOpenApiConformanceProof": "platform-openapi-conformance-proof.json",
    "requiredLiveReadbackArtifact": "platform-live-api-readback-proof.json",
    "productionPublishOverclaimPrevented": true,
    "studioFilesTouched": false,
    "requiredProjectEnvelopeSchemaVersion": "cogo.housing.studio-project-envelope.v1",
    "requiredStudioGenerationEvidenceSchemaVersion": "studio-generation-evidence.v1",
    "requiredStudioPublishReadinessGateSchemaVersion": "studio-publish-readiness-gate.v1"
  },
  "canonicalAssets": {
    "ontologyTbox": "packages/cogo-kg-browser/fixtures/backoffice-report-application-v1.ttl",
    "promotedAbox": "packages/cogo-kg-browser/fixtures/gridone-backoffice-report-application-v1.ttl",
    "validatorContract": "packages/cogo-validator/ontology/gridone-backoffice-report-contract-v1.json",
    "kgWorkerRoute": "/kg/find-backoffice-report-assets"
  }
}
